import classNames from 'classnames';
import analytics from 'service/analytics';
import styles from './create-license-plate-card.module.sass';
import { ArrowRightCircleIcon } from 'icons';

export const CreateLicensePlateCard = ({ maxOfLicensePlates, numberOfLicensePlates, onClick }) => {
  const hint =
    numberOfLicensePlates > 0
      ? `已設定 ${numberOfLicensePlates} 張，還可新增 ${maxOfLicensePlates - numberOfLicensePlates} 張`
      : `可新增 ${maxOfLicensePlates} 張`;

  return (
    <div
      className={classNames(styles['toggle-box'])}
      onClick={() => {
        analytics.licensePlatesCreateLicensePlateButtonClick();
        onClick();
      }}
    >
      <div className={styles['toggle-box-left-section']}>
        <p className={styles['title']}>新增付款車牌</p>
        <p className={styles['description']}>{hint}</p>
      </div>
      <ArrowRightCircleIcon />
    </div>
  );
};
